<template>
  <div class="faq-page">
    <main-header />
    
    <div class="container faq-container">
      <h1 class="page-title">Questions & Answers</h1>
      
      <div class="faq-list">
        <div class="faq-item" v-for="(faq, index) in faqs" :key="index">
          <button 
            class="faq-question" 
            @click="toggleFAQ(index)"
            :class="{ active: activeFAQ === index }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" class="question-icon">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
            </svg>
            <span>{{ faq.question }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" class="chevron-icon" :class="{ rotated: activeFAQ === index }">
              <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
            </svg>
          </button>
          <transition name="fade">
            <div v-if="activeFAQ === index" class="faq-answer">
              <p>{{ faq.answer }}</p>
            </div>
          </transition>
        </div>
      </div>
    </div>
    
    <main-footer />
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import MainFooter from '@/components/MainFooter.vue';

export default {
  name: 'FAQView',
  components: {
    MainHeader,
    MainFooter
  },
  data() {
    return {
      activeFAQ: null,
      faqs: [
        {
          question: 'Can I customize the products with my own pet?',
          answer: 'Yes! You can upload your pet\'s photo and select features to create custom designs for each item.'
        },
        {
          question: 'Which types of pets can be customized?',
          answer: 'We support dogs, cats, rabbits, birds, and even small pets like ferrets and hedgehogs. Just choose your pet type at your personalization journey!'
        },
        {
          question: 'How long does customization and delivery take?',
          answer: 'Customization takes 5-15 mins to complete. It will take a few days for our designers to personalize for you, and shipping typically adds 7–14 days depending on your location.'
        },
        {
          question: 'What if I have more than one pet?',
          answer: 'Currently, each box supports one pet per order. For multiple pets, you can use the additional customization option for a premium upgrade.'
        },
        {
          question: 'Is this a good gift for someone else?',
          answer: 'Absolutely! It\'s a thoughtful, personalized gift for any pet lover. You can even include a gift message at checkout.'
        }
      ]
    };
  },
  methods: {
    toggleFAQ(index) {
      this.activeFAQ = this.activeFAQ === index ? null : index;
    }
  }
};
</script>

<style scoped>
.faq-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.faq-container {
  flex: 1;
  padding: 6rem 2rem;
  max-width: 900px;
  margin: 0 auto;
}

.page-title {
  font-size: 4rem;
  font-weight: 700;
  color: var(--text);
  text-align: center;
  margin-bottom: 5rem;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.faq-item {
  border: 2px solid var(--grey-2);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.faq-item:hover {
  border-color: var(--dark-green);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.faq-question {
  width: 100%;
  padding: 2rem 2.5rem;
  background-color: white;
  border: none;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  cursor: pointer;
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--text);
  text-align: left;
  transition: all 0.3s ease;
}

.faq-question:hover {
  background-color: #f9f9f9;
}

.faq-question.active {
  background-color: var(--cosmic-latte);
  color: var(--dark-green);
}

.question-icon {
  flex-shrink: 0;
  color: var(--dark-green);
}

.faq-question span {
  flex: 1;
}

.chevron-icon {
  flex-shrink: 0;
  transition: transform 0.3s ease;
  color: var(--dark-green);
}

.chevron-icon.rotated {
  transform: rotate(180deg);
}

.faq-answer {
  padding: 2rem 2.5rem 2.5rem 6rem;
  background-color: #fafafa;
  border-top: 1px solid var(--grey-2);
}

.faq-answer p {
  font-size: 1.6rem;
  line-height: 1.8;
  color: var(--text);
  margin: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 768px) {
  .page-title {
    font-size: 3rem;
    margin-bottom: 3rem;
  }
  
  .faq-question {
    padding: 1.5rem 2rem;
    font-size: 1.6rem;
  }
  
  .faq-answer {
    padding: 1.5rem 2rem 2rem 5rem;
  }
  
  .faq-answer p {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .faq-container {
    padding: 4rem 1.5rem;
  }
  
  .page-title {
    font-size: 2.5rem;
  }
  
  .faq-question {
    padding: 1.2rem 1.5rem;
    font-size: 1.5rem;
    gap: 1rem;
  }
  
  .question-icon {
    width: 18px;
    height: 18px;
  }
  
  .faq-answer {
    padding: 1.2rem 1.5rem 1.5rem 4.5rem;
  }
}
</style>
